var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{attrs:{"src":_vm.src,"alt":_vm.content}}),_vm._v(" "),_c('span',{staticStyle:{"display":"none"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }